<!--  -->
<template>
  <div class="page">
    <van-nav-bar
      class="backBox"
      title="续租延期"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="mainBox">
      <div class="monthBox" v-if="detail.monthOrGroup === 'month'||detail.monthOrGroup === 'store'">
        <div class="title boxItem">
          <div class="img">
            <img
              src="../../../assets/img/paymentRecordleft@2x.png"
              class="mainBoxLeftIcon"
            />
          </div>

          <span class="vhNum">{{ detail.plate_number }}</span>
          <span class="vhCate">{{ detail.vh_cate_name }}</span>
        </div>
        <!-- <van-divider /> -->

        <!-- <div class="nowDates boxItem">
          <div class="leftTit">当前月租时段：</div>
          <div class="rightValue">
            {{ timeFormatter(detail.create_time) }} -
            {{ timeFormatter(detail.effective_date_end) }}
          </div>
        </div>
        <div class="newDates boxItem">
          <div class="leftTit">续租时段：</div>
          <div class="rightValue">
            {{ showRentStartTime}} -
            {{ showRentEndTime }}
          </div>
        </div>
        <div class="newDates boxItem">
          <div class="leftTit">规则：</div>
          <div class="rightValue">
            {{detail.vh_cate_name}}：{{detail.month_rent / 100}}元/月
          </div>
        </div> -->
        <div class="nowDates boxItem" v-if="detail.monthOrGroup === 'month'">
          <div class="leftTit">规格：</div>
          <div class="rightValue" @click="openMonthUnitPopup">
            {{
              monthUnitColumnsLocal.length
                ? monthUnitColumnsLocal[monthUnitIndex].month_count_name
                : ""
            }}
            <van-icon name="arrow" color="#1989fa" />
          </div>
          <van-popup
            v-model="showMonthUnitPopup"
            @close="onMonthUnitClose"
            position="bottom"
          >
            <van-picker
              :columns="monthUnitColumnsLocal"
              @change="onMonthUnitChange"
              @confirm="onMonthUnitConfirm"
              @cancel="onMonthUnitCancel"
              show-toolbar
              title="选择规格"
              visible-item-count="3"
              default-index="0"
              value-key="month_count_name"
            />
          </van-popup>
        </div>
        <div class="newDates boxItem" v-if="detail.monthOrGroup === 'month'">
          <div class="leftTit">价格：</div>
          <div class="rightValue">
            {{
              monthUnitColumnsLocal.length
                ? monthUnitColumnsLocal[monthUnitIndex].current_price / 100
                : 0
            }}元
          </div>
        </div>
         <!-- 储值车输入价格 -->
            <div class="newDates boxItem" v-if="detail.monthOrGroup==='store'">
              <div class="leftTit">储值金额：</div>
              <div class="rightValue">
                <van-field
                  v-model="storeNum"
                  type="digit"
                  label=""
                  input-align="right"
                  clearable
                  placeholder="请输入储值金额"
                  @blur="storeValInput()"
                  @input="storeValInput()"
                />
              </div>
            </div>
      </div>

      <div class="groupWrapBox" v-if="detail.monthOrGroup === 'group'">
        <div class="groupBoxItem">
          <!-- <div class="names">
            <span class="groupName">{{ detail.vh_group_id }} </span>
          </div> -->
          <div class="dates">
            <span class="vhNum">{{ detail.plate_number }}</span>
            <span class="vhCate" v-if="detail.group_vh_charge_mobile_type===1">{{ detail.vh_cate_name }}</span>
            <span class="vhCate vhGroupName" v-if="detail.group_vh_charge_mobile_type!==1">{{ detail.group_info&&detail.group_info.name?detail.group_info.name :''}}</span>
          </div>
          <div class="plates" v-if="detail.group_vh_charge_mobile_type!==1">
            <div
              v-for="(plateItem, plateIndex) in vhPlates"
              :key="plateIndex"
              :class="[
                'platesShowItem'
              ]"
            >
              <span
                :class="[
                  detail.plate_number === plateItem.plate_number
                    ? 'specialVh'
                    : '',
                ]"
                >{{ plateItem.plate_number }}</span
              >
              <span :class="[
                  detail.plate_number === plateItem.plate_number
                    ? 'specialVh'
                    : '',
                ]">{{ plateItem.vh_cate_name }}</span>
            </div>
          </div>

          <div class="showWhenSelGroup" >
            <van-divider v-if="detail.group_vh_charge_mobile_type!==1" />
            <div class="monthFooter">
              <div class="leftTit">{{ showSelVhCate(detail) }}</div>
              <!-- <div class="">
                <van-stepper v-model="monthNum" integer />
              </div> -->
            </div>
            <!-- <div class="monthFooter monthFooterDate">
              <div class="leftTit">续租时间</div>
              <div class="rightValue">
              </div>
            </div> -->
             <div class="newDates boxItem"  v-if="detail.monthOrGroup!=='store' && detail.group_vh_charge_mobile_type===2">
              <div class="leftTit">车位数：</div>
              <div class="rightValue">
                {{ vhSpace }}
              </div>
            </div>
            <div class="nowDates boxItem"  v-if="detail.monthOrGroup!=='store' && detail.group_vh_charge_mobile_type!==3">
              <div class="leftTit">规格：</div>
              <div class="rightValue" @click="openMonthUnitPopup">
                {{
                  monthUnitColumnsLocal.length
                    ? monthUnitColumnsLocal[monthUnitIndex].month_count_name
                    : ""
                }}
                <van-icon name="arrow" color="#1989fa" />
              </div>
              <van-popup
                v-model="showMonthUnitPopup"
                @close="onMonthUnitClose"
                position="bottom"
              >
                <van-picker
                  :columns="monthUnitColumnsLocal"
                  @change="onMonthUnitChange"
                  @confirm="onMonthUnitConfirm"
                  @cancel="onMonthUnitCancel"
                  show-toolbar
                  title="选择规格"
                  visible-item-count="3"
                  default-index="0"
                  value-key="month_count_name"
                />
              </van-popup>
            </div>
            <div class="newDates boxItem"  v-if="detail.monthOrGroup!=='store' && detail.group_vh_charge_mobile_type!==3">
              <div class="leftTit">价格：</div>
              <div class="rightValue">
                {{
                  monthUnitColumnsLocal.length
                    ? monthUnitColumnsLocal[monthUnitIndex].current_price / 100
                    : 0
                }}元
              </div>
            </div>

            <!-- 储值车输入价格 -->
            <div class="newDates boxItem" v-if="(detail.monthOrGroup==='group'&& detail.group_vh_charge_mobile_type===3)||detail.monthOrGroup==='store'">
              <div class="leftTit">储值金额：</div>
              <!-- TODO开发时使用 type="number"；正式发布时需要type="digit" -->
              <div class="rightValue">
                <van-field
                  v-model="storeNum"
                  type="digit"
                  label=""
                  input-align="right"
                  clearable
                  placeholder="请输入储值金额"
                  @blur="storeValInput()"
                  @input="storeValInput()"
                />
              </div>
            </div>
            <!-- <van-divider /> -->
          </div>
        </div>
      </div>
      <!-- 储值车不展示续租月数 -->
      <div class="boxItem otherItem"  v-if="(detail.monthOrGroup !== 'group' || detail.group_vh_charge_mobile_type !== 3) && detail.monthOrGroup !== 'store'">
        <span class="leftTit">购买数量</span>
        <div class="">
          <van-stepper v-model="monthNum" integer @change="onChangeStep" />
        </div>
      </div>
      <div class="dateBox" v-if="!(detail.monthOrGroup === 'group' && detail.group_vh_charge_mobile_type === 3) && detail.monthOrGroup !== 'store'">
        <div class="boxItem otherItem">
        <div class="leftTit">延期开始时间</div>
        <div class="showDateCaseText" v-if="showDateCase">
          <span v-if="showDateCase===1">到期后，车辆入场，多日后充值延期</span>
          <span v-if="showDateCase===2">到期后，车辆入场当天进行充值延期</span>
          <span v-if="showDateCase===3">到期后，车辆没有入场进行充值延期</span>
        </div>
        <div class="rightDateCaseText" v-if="!showDateRadio">
          <!-- 到期时间+1天 -->
          {{dueDateVal}}
        </div>
      </div>
         <van-radio-group v-if="showDateRadio" v-model="timeRadio">
        <van-cell-group>
          <van-cell :title="dueDate" style="text-align: left;font-size: 16px;color: #000;"  clickable @click="timeRadio = '1'">
            <template #right-icon>
              <van-radio name="1" />
            </template>
          </van-cell>
          <van-cell :title="vhInDate" style="text-align: left;font-size: 16px;color: #000;" clickable @click="timeRadio = '2'">
            <template #right-icon>
              <van-radio name="2" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      </div>

      <div class="boxItem otherItem">
        <div class="leftTit">共计</div>
        <div class="rightMoney">
          {{ payMoney }} <span class="rightValue">元</span>
        </div>
      </div>
      <div class="otherTipItem" v-if="detail.monthOrGroup==='group'&& detail.group_vh_charge_mobile_type===2">
        <div class="leftTitDesc">该分组车辆包月金额:</div>
        <div class="rightMoneyDesc">
         车位数*单个车位包月价格*购买数量
        </div>
      </div>

      <div class="btnOperation">
        <van-button
          @click="onClickPay"
          class="query_btn"
          :disabled="payBtnLoading"
        >
          <span class="query_btn_text">确认支付</span>
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as common from '../../../api/common'
import * as chargeService from '../../../api/chargeService'
import * as api from '../../../api/api'
import * as paycloudService from '../../../api/paycloudService'
import * as util from '../../../api/util'
import * as constant from '../../../api/constant'
import { mapState, mapGetters } from 'vuex'
import CarKeyboard from '../../../components/CarKeyboard.vue'
import { Dialog, Toast } from 'vant'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      detail: {},
      monthNum: 1,
      payMoney: 0,
      vhSpace: 1,
      defaultRent: '', // 默认月租金
      payBtnLoading: false,
      isVueReady: false,
      isTypeReady: false,
      isPress: false,
      showRentStartTime: '',
      showRentEndTime: '',
      tempBack: {
        expireMillSeconds: 240 * 1000,
        timeout: null,
        timestamp: 0
      },
      code: '',
      appidLocal: '',

      showMonthUnitPopup: false,
      monthUnitColumnsList: [
        // {
        //   id: 0,
        //   name: '规格1',
        //   money: 1000
        // },
        // {
        //   id: 1,
        //   name: '规格2',
        //   money: 2000
        // }
      ],
      monthUnitColumnsLocal: [
        // '规格1', '规格2'
        // {
        //   id: 0,
        //   name: '规格1',
        //   money: 1000
        // },
        // {
        //   id: 1,
        //   name: '规格2',
        //   money: 2000
        // }
      ],
      monthUnitIndex: 0,
      selMonthPrice: '',
      isStore: false,
      storeNum: '',
      defaultMoney: 0,
      group_vh_charge_mobile_type: '',
      vhPlates: [],
      theChargeType: '',
      timeRadio: '',
      dueDateVal: '2024-12-12',
      vhInDateVal: '2024-11-12',
      showDateRadio: false,
      showDateCase: null
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(['vhColumns', 'openID', 'thePayType']),
    ...mapState({
      // payType: state => state.payType.payType,
      sid: (state) => state.sid.sid,
      appid: (state) => state.appid.appid
    }),
    dueDate () {
      return '到期日+1天 ' + this.dueDateVal
    },
    vhInDate () {
      const label = this.showDateCase === 3 ? '今日 \u3000' : '入场日 '
      return label + this.vhInDateVal
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    showSelVhCate (row) {
      let name = ''
      if (row.group_info) {
        if (row.group_info.vh_list.length > 0) {
          const vhList = row.group_info.vh_list
          vhList.forEach((x) => {
            if (x.plate_number === this.detail.plate_number) {
              name = this.detail.vh_cate_name
            }
          })
        }
      }
      return name
    },
    storeValInput () {
      this.payMoney = this.storeNum
    },
    openMonthUnitPopup () {
      this.showMonthUnitPopup = true
    },
    onMonthUnitChange () {},
    onMonthUnitConfirm (value, index) {
      this.monthUnitIndex = index
      this.selMonthPrice = value.money / 100
      this.showMonthUnitPopup = false
      // 更新合计金额
      this.countMoney(
        this.monthUnitColumnsLocal[this.monthUnitIndex].current_price / 100,
        this.monthNum
      )
      // 整理 默认月租金
      this.defaultMoney = 0
      if (this.monthUnitColumnsLocal[this.monthUnitIndex].month_count === 1) {
        this.defaultMoney = this.monthUnitColumnsLocal[this.monthUnitIndex].current_price
      } else {
        this.defaultMoney = 0
      }
    },
    onMonthUnitCancel () {
      this.showMonthUnitPopup = false
    },
    onMonthUnitClose () {
      this.showMonthUnitPopup = false
    },
    // 计算续租时段的展示
    countRentDate (eDate) {
      const endTime = util.countRentTimeShow(eDate, this.monthNum)
      this.showRentStartTime = util.getNextDay(eDate)
      this.showRentEndTime = endTime
    },
    // 计算延期后的有效期（开始时间和结束时间）
    calculatePostponePeriod () {
      const theGetChargeType = this.getChargeType()
      let startDate = ''
      let totalMonths = 0

      if (theGetChargeType === constant.monthRentInfos.chargeType.vhStore) {
        // 储值车：从当前时间开始，12个月
        startDate = common.format(new Date(), 'yyyy-MM-dd')
        totalMonths = 12
      } else if (theGetChargeType === constant.monthRentInfos.chargeType.vhGroupStore) {
        // 分组储值车：不适用，返回空
        return { startDate: '', endDate: '' }
      } else {
        // 其他类型：根据选择的开始时间
        if (!this.showDateRadio) {
          // 没有日期选择，使用到期日的下一天
          startDate = util.getNextDay(this.detail.effective_date_end || this.detail.current_effective_date_end)
        } else {
          // 有日期选择，根据选择的日期
          if (this.timeRadio === '1') {
            // dueDateVal 已经是到期日的下一天了，直接使用
            startDate = this.dueDateVal
          } else {
            // vhInDateVal 已经是期望的开始日期（入场日或今日），直接使用
            startDate = this.vhInDateVal
          }
        }

        // 计算总月数：购买数量 * 规格月数
        if (this.monthUnitColumnsLocal.length > 0) {
          const monthCount = this.monthUnitColumnsLocal[this.monthUnitIndex].month_count || 1
          totalMonths = this.monthNum * monthCount
        } else {
          totalMonths = this.monthNum
        }
      }

      // 计算结束日期
      // 延期N个月应该是：开始日期 + N个月 - 1天
      // 例如：1月27日开始延期1个月，应该是1月27日~2月26日
      const startDateObj = new Date(startDate)
      const endDateObj = new Date(startDateObj)
      endDateObj.setMonth(endDateObj.getMonth() + totalMonths)

      // 处理月末日期的情况
      const originalDay = startDateObj.getDate()
      if (endDateObj.getDate() < originalDay) {
        endDateObj.setDate(0) // 设置为上个月的最后一天
      } else {
        endDateObj.setDate(originalDay)
      }

      // 减1天，因为延期N个月应该是到"开始日期+N个月-1天"
      // 例如：1月27日延期1个月，应该是1月27日~2月26日（而不是2月27日）
      endDateObj.setDate(endDateObj.getDate() - 1)

      const endDate = common.format(endDateObj, 'yyyy-MM-dd')

      return { startDate, endDate }
    },
    getTempBackTimeout () {
      const ms = this.tempBack.expireMillSeconds
      if (!this.tempBack.timestamp) {
        this.tempBack.timestamp = new Date().getTime()
      }
      this.tempBack.timeout = setTimeout(() => {
        this.expireGoBack()
        this.clearBackTimeout()
      }, ms)
    },
    clearBackTimeout () {
      clearTimeout(this.tempBack.timeout)
      this.tempBack.timeout = null
    },
    expireGoBack () {
      this.tempBack.timestamp = 0
      this.$dialog
        .alert({
          title: '支付超时',
          message: '点击“确认”后重试'
        })
        .then(() => {
          // this.setDataWhenErrorConfirm()
          this.onClickLeft()
        })
    },
    clearSessionData () {
      sessionStorage.removeItem(constant.keyBusinessInfoSession)
      sessionStorage.removeItem(constant.keySaveInfoSession)
      sessionStorage.removeItem(constant.keyMonthUnitColumnsListSession)
    },
    setButtonClertload () {
      this.$nextTick(() => {
        this.isTypeReady = true
      })
    },
    wxReadyToPay (payargs) {
      console.log('wxReadyToPay---', payargs)
      var that = this
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener(
            'WeixinJSBridgeReady',
            that.onBridgeReady(payargs),
            false
          )
        } else if (document.attachEvent) {
          document.attachEvent(
            'WeixinJSBridgeReady',
            that.onBridgeReady(payargs)
          )
          document.attachEvent(
            'onWeixinJSBridgeReady',
            that.onBridgeReady(payargs)
          )
        }
      } else {
        that.onBridgeReady(payargs)
      }
    },
    resolveWxAppId (payargs) {
      if (payargs.appId != null && payargs.appId !== '') return payargs.appId
      if (payargs.app_id != null && payargs.app_id !== '') return payargs.app_id
      return this.appid || this.appidLocal || ''
    },
    async getPayType () {
      const sidNow = this.sid || this.$route.query.sid
      if (!sidNow) return
      try {
        const thePayType = await paycloudService.getPayTypeBySid(sidNow)
        this.$store.commit(constant.keyPayTypeVuex, thePayType)
      } catch (error) {
        console.error('[postponeDetail] getPayType failed:', error)
      }
    },
    async ensurePayContext () {
      await this.getPayType()
      if (common.getUserAgent() === common.userAgentInfo.wx) {
        const sidNow = this.sid || this.$route.query.sid
        if (sidNow && !this.appid && !this.appidLocal) {
          try {
            await this.getAppId()
          } catch (e) {
            console.warn('[postponeDetail] 预取 appId 失败', e)
          }
        }
      }
    },
    onBridgeReady (payargs) {
      var that = this
      // return
      const payType = Number(this.thePayType)
      if (payType === common.payType.wx || payType === common.payType.zero) {
        // 微信直联
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            appId: that.resolveWxAppId(payargs),
            timeStamp: payargs.timeStamp || payargs.timestamp, // 时间戳，自1970年以来的秒数
            nonceStr: payargs.nonceStr || payargs.nonce_str, // 随机串
            package: payargs.package,
            signType: payargs.signType != null ? payargs.signType : 'MD5', // 微信签名方式：
            paySign: payargs.paySign || payargs.sign // 微信签名
          },
          function (res) {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              // that.$toast.success('支付完成')
              // // that.$router.replace('/index')
              // that.$router.replace({
              //   path: '/index',
              //   query:{
              //     sid: this.$Storejs.getItem('sid'),
              //     channel_path: this.$Storejs.getItem('channel_path')
              //   }
              // })
              // that.$toast({
              //   type: 'success',
              //   message: '支付完成',
              //   duration: 0,
              //   forbidClick: true
              // })
              window.location.replace(
                'https://pa03.yuntingiot.com/api/ac/477786592149311488'
              )
              // WeixinJSBridge.call('closeWindow')
            } else {
              that.$dialog
                .alert({
                  // showCancelButton: true,
                  title: '支付失败'
                })
                .then(() => {
                  that.onClickLeft()
                  // that.setDataWhenErrorConfirm()
                })
            }
          }
        )
      } else if (payType === common.payType.bjyz) {
        // 微信云纵间联
        // const pars = {
        //   start_time: this.start_time,
        //   hour: this.hour,
        //   min: this.min,
        //   seconds: this.seconds,
        //   actually_paid: this.actually_paid,
        //   couponPrice1: this.couponPrice1,
        //   invoice_url: payargs.invoice_url,
        //   sid: this.sid,
        //   parkName: this.parkName,
        //   plateNumber: this.plate_number
        // }
        // this.$store.commit(constant.keyAdverInfoVuex, pars)

        this.isPress = true
        window.location.replace(payargs.trade_url)
        //            window.location.href = payargs.trade_url;
      } else if (payType === common.payType.pp) {
        // 微信PP间联
        // 保存月租相关的支付完成信息  等支付完成跳转展示。如果支付平台没有支付完成展示页面则需要展示
        const pars = {
          monthPaySuccess: true
        }

        this.$store.commit(constant.keyAdverInfoVuex, pars)

        this.isPress = true
        // this.payBtnLoading = false
        window.location.replace(payargs.pay_url)
        // pay_url: "https://auth.4pyun.com/authorize?scope=snsapi_base&redirect_uri=https%3A%2F%2Fapp.4pyun.com%2Fpayment%2Ftrade%2Fcreate%3Fpay_id%3D983768955900399617"

        //            window.location.href = payargs.trade_url;
      } else if (payType === common.payType.icbc) {
        // 微信工商间联
        // 保存月租相关的支付完成信息  等支付完成跳转展示。如果支付平台没有支付完成展示页面则需要展示
        const pars = {
          monthPaySuccess: true
        }

        this.$store.commit(constant.keyAdverInfoVuex, pars)

        this.isPress = true
        // this.payBtnLoading = false
        window.location.replace(payargs.pay_url)
        // pay_url: "https://auth.4pyun.com/authorize?scope=snsapi_base&redirect_uri=https%3A%2F%2Fapp.4pyun.com%2Fpayment%2Ftrade%2Fcreate%3Fpay_id%3D983768955900399617"

        //            window.location.href = payargs.trade_url;
      } else if (payType === common.payType.abc) {
        // 微信农行间联
        const pars = {
          monthPaySuccess: true
        }

        that.$store.commit(constant.keyAdverInfoVuex, pars)

        this.isPress = true

        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            appId: that.resolveWxAppId(payargs),
            timeStamp: payargs.timeStamp || payargs.timestamp, // 时间戳，自1970年以来的秒数
            nonceStr: payargs.nonceStr || payargs.nonce_str, // 随机串
            package: payargs.package,
            signType: payargs.signType != null ? payargs.signType : 'MD5', // 微信签名方式：
            paySign: payargs.paySign || payargs.sign // 微信签名
          },
          function (res) {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              // 使用以上方式判断前端返回,微信团队郑重提示：
              // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              // that.$toast.success('支付完成')
              // // that.$router.replace('/index')
              // that.$router.replace({
              //   path: '/index',
              //   query:{
              //     sid: this.$Storejs.getItem('sid'),
              //     channel_path: this.$Storejs.getItem('channel_path')
              //   }
              // })
              // that.$toast({
              //   type: 'success',
              //   message: '支付完成',
              //   duration: 0,
              //   forbidClick: true
              // })
              window.location.replace(
                'https://pa03.yuntingiot.com/api/ac/477786592149311488'
              )
              // WeixinJSBridge.call('closeWindow')
            } else {
              that.$dialog
                .alert({
                  // showCancelButton: true,
                  title: '支付失败'
                })
                .then(() => {
                  that.onClickLeft()
                  // that.setDataWhenErrorConfirm()
                })
            }
          }
        )
      } else if (payType === common.payType.lanzhoubank) {
        // 兰州银行微信
        const pars = {
          monthPaySuccess: true
        }

        that.$store.commit(constant.keyAdverInfoVuex, pars)

        this.isPress = true
        window.location.replace(payargs.billQRCode)
      } else if (payType === common.payType.ningbobank) {
        // 宁波银行微信
        const pars = {
          monthPaySuccess: true
        }

        this.$store.commit(constant.keyAdverInfoVuex, pars)

        this.isPress = true
        window.location.replace(payargs.pay_url)
      }
    },
    WX_Bridge_ready (cb) {
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', cb(), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', cb())
          document.attachEvent('onWeixinJSBridgeReady', cb())
        }
      } else {
        cb()
      }
    },
    doPay () {
      const that = this
      Toast.loading({
        forbidClick: true,
        message: '请稍候...'
      })

      const sessionStorageLocal = JSON.parse(
        sessionStorage.getItem(constant.keyBusinessInfoSession)
      )
      const grossPrice = parseFloat(this.payMoney) * 100
      const actuallyPaid = parseFloat(this.payMoney) * 100

      let subject = ''

      // const { monthOrGroup } = this.detail
      const monthOrGroup = this.detail.monthOrGroup
      const group_vh_charge_mobile_type = this.detail.group_vh_charge_mobile_type ? this.detail.group_vh_charge_mobile_type : ''
      const groupName = sessionStorageLocal.group_name || ''
      const plateNumber = sessionStorageLocal.plate_number || ''
      const monthUnitColumns = this.monthUnitColumnsLocal || []
      const monthUnitName = monthUnitColumns[this.monthUnitIndex]?.name || ''

      if (monthOrGroup === 'group') {
        subject = group_vh_charge_mobile_type === 3
          ? `分组${groupName}储值充值`
          : `${plateNumber}${monthUnitName}服务续费`
      } else if (monthOrGroup === 'store') {
        subject = `${plateNumber}储值充值`
      } else {
        subject = `${plateNumber}${monthUnitName}充值延期`
      }

      chargeService
        .getPayargsMonth(
          this.sid,
          grossPrice,
          actuallyPaid,
          Number(this.thePayType) === 0 ? 1 : Number(this.thePayType),
          subject,
          sessionStorageLocal,
          this.code
        )
        .then((payargs) => {
          // this.payBtnLoading = false
          that.$toast.clear()
          that.isPress = false
          console.log('getPayargsMonth----', payargs)
          if (!payargs) {
            that.$dialog
              .alert({
                title: '支付失败'
              })
              .then(() => {
                that.onClickLeft()
                // that.setDataWhenErrorConfirm()
              })
            return
          }
          if (common.getUserAgent() === common.userAgentInfo.wx) {
            that.wxReadyToPay(payargs)
          } else if (common.getUserAgent() === common.userAgentInfo.zfb) {
            that.do_zfb_pay(payargs)
          }
        })
        .catch((e) => {
          console.log('获取支付平台res', e)
          that.$toast.clear()
          that.isPress = false
          if (parseFloat(grossPrice) > 0) {
            console.log(e)
            that.$dialog
              .alert({
                // showCancelButton: true,
                title: '支付失败',
                message: e
              })
              .then(() => {
                that.onClickLeft()
                // that.setDataWhenErrorConfirm()
              })
          } else that.$toast.clear()
        })
    },
    setDataWhenErrorConfirm () {
      this.payBtnLoading = false
      const sessionStorageLocal = JSON.parse(
        sessionStorage.getItem(constant.keyBusinessInfoSession)
      )
      const saveInfo = JSON.parse(
        sessionStorage.getItem(constant.keySaveInfoSession)
      )

      const monthUnitColumnsListNew = JSON.parse(
        sessionStorage.getItem(constant.keyMonthUnitColumnsListSession)
      )
      if (monthUnitColumnsListNew) {
        this.monthUnitColumnsLocal = monthUnitColumnsListNew
      }

      console.log('获取到的code：', this.code)
      console.log('获取到的code：', this.$route.query.code)
      // 点击支付获取code后会重新来到该页面 走挂载，点击支付后需要设置是否点击了支付按钮的标志，挂载中判断是否已经点击，
      // 已经点击，且有code，则直接访问支付接口获取支付回调地址。否则不执行
      if (sessionStorageLocal && saveInfo) {
        // 数据回显
        this.detail = sessionStorageLocal
        // this.monthUnitIndex = saveInfo.monthUnitIndex
        this.detail.monthOrGroup = sessionStorageLocal.monthOrGroup
        if (saveInfo.group_vh_charge_mobile_type) {
          this.detail.group_vh_charge_mobile_type = saveInfo.group_vh_charge_mobile_type
        }

        if (sessionStorageLocal.specs_count !== undefined) {
          this.monthNum = sessionStorageLocal.specs_count || ''
        }
        if (saveInfo.monthUnitIndex !== undefined) {
          this.monthUnitIndex = saveInfo.monthUnitIndex
        }
        this.vhSpace = this.saveInfo.vhSpace
        // 当没有规格时，构造规格
        if (this.monthUnitColumnsLocal.length > 0) {
          this.countMoney(
            this.monthUnitColumnsLocal[this.monthUnitIndex].current_price / 100,
            this.monthNum
          )
        } else {
          this.storeNum = Number(saveInfo.storeNum)
          this.payMoney = this.storeNum
        }
      }
    },
    // 购买数量
    onChangeStep () {
      this.countMoney(
        this.monthUnitColumnsLocal[this.monthUnitIndex].current_price / 100,
        this.monthNum
      )
      this.countRentDate(this.detail.effective_date_end || this.detail.current_effective_date_end)
    },
    countMoney (money, month) {
      console.log('countMoney方法', money, month, this.vhSpace)
      this.payMoney = parseFloat((money * month * this.vhSpace).toFixed(2))
    },
    async onClickPay () {
      if (!this.sid) {
        return Toast.fail('车场编号丢失，请返回重试')
      }
      if ((this.detail.monthOrGroup === 'group' && this.group_vh_charge_mobile_type === 3) || this.detail.monthOrGroup === 'store') {
        if (this.storeNum === '' || this.storeNum < 0) {
          return Toast.fail('请输入储值金额')
        }
        if (this.storeNum > 10000) {
          return Toast.fail('储值金额不能超过10000元')
        }
      }
      if (this.payMoney <= 0) {
        return Toast.fail('应付金额为0')
      }
      // 如果是储值车 则不需要显示确认信息 直接继续执行
      if (this.detail.monthOrGroup === 'store') {
        return this.continuePayProcess()
      }
      // 计算延期后的有效期
      const postponePeriod = this.calculatePostponePeriod()
      if (!postponePeriod.startDate || !postponePeriod.endDate) {
        // 如果是分组储值车等不需要显示有效期的情况，直接继续
        return this.continuePayProcess()
      }

      // 显示延期后的有效期弹窗
      const plateNumber = this.detail.plate_number || ''
      const message = `车辆${plateNumber}延期后的有效期为${postponePeriod.startDate}~${postponePeriod.endDate}`

      Dialog.confirm({
        title: '确认延期信息',
        message: message,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        // 点击确认，继续执行
        this.continuePayProcess()
      }).catch(() => {
        // 点击取消，关闭弹窗，不执行后续操作
        // 不需要做任何操作，弹窗会自动关闭
      })
    },
    // 继续支付流程
    continuePayProcess () {
      if (!this.isVueReady) {
        return this.$toast('努力加载中.')
      } else if (!this.isTypeReady) {
        if (common.getUserAgent() === common.userAgentInfo.wx) {
          return this.$toast('微信努力加载中.')
        } else {
          return this.$toast('支付宝努力加载中.')
        }
      }
      this.payBtnLoading = true
      Toast.loading({
        forbidClick: true,
        message: '请稍候...'
      })
      // let payWay = common.payWay.weichat
      // if (common.getUserAgent() === 'wx') {
      //   payWay = common.payWay.weichat
      // } else if (common.getUserAgent() === 'zfb') {
      //   payWay = common.payWay.alipay
      // }
      const theGetChargeType = this.getChargeType()
      const businessInfo = {
        business_type: constant.monthRentInfos.businessType,
        charge_type: theGetChargeType,
        plate_number: this.detail.plate_number

        // effective_date_end: this.detail.effective_date_end
      }
      // if (this.detail.monthOrGroup === 'group') {
      //   businessInfo.charge_start_time = util.getChargeStartTimeNew(this.detail.effective_date_end)
      // } else {
      //   businessInfo.charge_start_time = util.getNextDayStart(this.detail.effective_date_end)
      // }
      // if (this.detail.monthOrGroup !== 'group') {

      // }
      if (theGetChargeType !== constant.monthRentInfos.chargeType.vhGroupStore) {
        businessInfo.vh_cate_id = Number(this.detail.vh_cate_id)
        businessInfo.vh_type_id = Number(this.detail.vh_type_id)
        if (theGetChargeType === constant.monthRentInfos.chargeType.vhStore) {
          businessInfo.month = 12
        }
        businessInfo.month = Number(
          this.monthUnitColumnsLocal[this.monthUnitIndex].month_count
        )
        businessInfo.specs_count = Number(this.monthNum)
        if (theGetChargeType === constant.monthRentInfos.chargeType.vhStore) {
          businessInfo.monthly_rent_fee = 0
          businessInfo.specs_rent_fee = 0
          businessInfo.charge_start_time = common.format(new Date(), 'yyyy-MM-dd hh:mm:ss')
        } else {
          businessInfo.monthly_rent_fee = this.defaultMoney
          businessInfo.specs_rent_fee = this.monthUnitColumnsLocal[this.monthUnitIndex].current_price ? this.monthUnitColumnsLocal[this.monthUnitIndex].current_price : this.detail.default_rent
          if (!this.showDateRadio) {
            console.log('!showDateRadio')
            businessInfo.charge_start_time = util.getNextDayStart(this.detail.effective_date_end || this.detail.current_effective_date_end)
          } else {
            console.log('showDateRadio')
            // console.log('this.timeRadio', this.timeRadio)
            // console.log('dueDateVal', this.dueDateVal)
            // console.log('vhInDateVal', this.vhInDateVal)
            // console.log('getChargeStartTimeNew1', util.getChargeStartTimeNew(this.dueDateVal))
            // console.log('getChargeStartTimeNew2', util.getChargeStartTimeNew(this.vhInDateVal))

            if (this.timeRadio === '1') {
              // 选择"到期日的下一天"
              businessInfo.charge_start_time = util.getNextDayStart(this.detail.effective_date_end || this.detail.current_effective_date_end)
            } else {
              // 选择"入场日"或"今日"
              // vhInDateVal 已经是期望的开始日期，直接设置为当天的零点
              const vhInDate = new Date(this.vhInDateVal)
              vhInDate.setHours(0, 0, 0, 0)
              businessInfo.charge_start_time = common.format(vhInDate, 'yyyy-MM-dd hh:mm:ss')
            }
          }
        }
      }
      if (theGetChargeType === constant.monthRentInfos.chargeType.vhGroupStore || theGetChargeType === constant.monthRentInfos.chargeType.vhGroupPostpone) {
        // businessInfo.group_name = this.detail.group_name
        businessInfo.group_name = this.detail.group_info ? this.detail.group_info.name : ''
      }
      if (theGetChargeType === constant.monthRentInfos.chargeType.vhGroupPostpone) {
        businessInfo.group_vh_site_num = this.vhSpace
      }
      if (theGetChargeType === constant.monthRentInfos.chargeType.vhStore) {
        // businessInfo.month = '长期有效'
        businessInfo.month = 12
      }
      console.log('---businessInfo---', businessInfo)
      // return
      // 数据回显时依赖数据
      const saveInfo = {
        month_number: this.monthNum,
        create_time: this.detail.create_time,
        monthUnitIndex: this.monthUnitIndex,
        monthOrGroup: this.detail.monthOrGroup,
        group_vh_charge_mobile_type: this.detail.group_vh_charge_mobile_type,
        storeNum: this.storeNum,
        vhSpace: this.vhSpace,
        vhInDateVal: this.vhInDateVal,
        dueDateVal: this.dueDateVal,
        timeRadio: this.timeRadio,
        showDateRadio: this.showDateRadio,
        showDateCase: this.showDateCase
      }
      sessionStorage.setItem(
        constant.keyMonthUnitColumnsListSession,
        JSON.stringify(this.monthUnitColumnsLocal)
      )
      sessionStorage.setItem(
        constant.keySaveInfoSession,
        JSON.stringify(saveInfo)
      )
      sessionStorage.setItem(
        constant.keyBusinessInfoSession,
        JSON.stringify(businessInfo)
      )
      console.log('businessInfo', businessInfo)
      console.log('saveInfo', saveInfo)
      // return
      // sessionStorage.setItem(constant.keyPayTypeSession, this.thePayType)
      // 微信或支付宝 code, type=1、2、41、0 时必须获取上传 code
      const comparePayType = Number(this.thePayType)

      if (
        comparePayType === common.payType.wx ||
        comparePayType === common.payType.zfb ||
        comparePayType === common.payType.abc ||
        comparePayType === common.payType.zero ||
        comparePayType === common.payType.icbc
      ) {
        // 需要code
        // 获取code

        this.getAllCode()
      } else {
        this.getTempBackTimeout()
        this.code = null
        this.doPay()
      }
    },
    // getDefaultMonthRent () {
    //   let str = 0
    //   if (this.monthOrGroup === 'store') {
    //     str = 0
    //   } else if (this.monthOrGroup === 'month') {

    //   }
    //   return str
    // },
    getChargeType () {
      console.log('当前的车展示类型', this.detail.monthOrGroup)
      let str = ''
      if (this.detail.monthOrGroup === 'month') {
        str = constant.monthRentInfos.chargeType.vhRenew
      } else if (this.detail.monthOrGroup === 'group') {
        if (this.group_vh_charge_mobile_type === 2) {
          // 给整个分组延期
          str = constant.monthRentInfos.chargeType.vhGroupPostpone
        } else if (this.group_vh_charge_mobile_type === 3) {
          str = constant.monthRentInfos.chargeType.vhGroupStore
        }
      } else if (this.detail.monthOrGroup === 'store') {
        str = constant.monthRentInfos.chargeType.vhStore
      }
      return str
    },
    getAllCode () {
      if (common.getUserAgent() === common.userAgentInfo.wx) {
        this.getAppId()
          .then((appid) => {
            window.location.href = common.getCodeObtainUrl(
              window.location,
              appid,
              true
            )
            console.log('window.location.href', window.location.href)
          })
          .catch((e) => {
            this.$toast('网络错误')
          })
      }
    },
    async getAppId () {
      const appId = await paycloudService.getAppIdWx(this.sid || this.$route.query.sid)
      if (appId) {
        this.appidLocal = appId
        this.$store.commit(constant.keyAppIDVuex, appId)
        return this.appidLocal
      } else {
        return Promise.reject(new Error('获取AppID失败'))
      }
    },
    // 根据续租月数，更新续租时间
    countMonthDate (item) {
      if (!item.startDate || !item.endDate) {
        return this.$toast('开始日期或结束日期不规范')
      }
      // 将startDate字符串转换为Date对象
      const startDate = new Date(item.startDate)
      const endDate = new Date(item.endDate)

      // 添加续租月数
      endDate.setMonth(endDate.getMonth() + this.monthNum)
      // 如果endDate小于startDate（考虑跨年情况），则增加年份
      if (endDate < startDate) {
        endDate.setFullYear(endDate.getFullYear() + 1)
      }
      // 将endDate转换回字符串格式
      const endDateStr = endDate.toISOString().split('T')[0] // ISO格式，日期部分

      return item.startDate + ' - ' + endDateStr
    },
    timeFormatter (para) {
      return common.format(new Date(para), 'yyyy-MM-dd')
    },
    onClickLeft () {
      // this.$router.go(-1)
      this.$router.replace(
        {
          path: '/reletPostpone'
        })
    },
    countVhDate () {
      console.log('参数detail', this.detail)
      // 情况一 车辆到期后，车辆入场，多日后充值延期
      // 情况二 车辆到期后，车辆入场当天充值延期
      // 情况三 车辆到期后，车辆没有入场进行充值延期
      // 其余情况 只展示一个到期时间+1天即可
      // ?本地测试打开
      // this.detail.amount = 1
      // this.detail.latest_in_time = '2024-11-13 12:12:12'
      // this.detail.effective_date_end = '2024-10-10 12:12:12'

      const amount = this.detail.amount ? Number(this.detail.amount) : 0
      const latest_in_time = this.detail.latest_in_time ? this.detail.latest_in_time : null
      const endDate = this.detail.effective_date_end || this.detail.current_effective_date_end ? common.format(this.detail.effective_date_end || this.detail.current_effective_date_end, 'yyyy-MM-dd hh:mm:ss') : null

      const today = new Date()
      this.dueDateVal = util.getNextDay(this.detail.effective_date_end || this.detail.current_effective_date_end)
      this.timeRadio = '1'

      if (new Date(endDate) < today) {
        // 车辆到期
        // 场景6：入场时间在到期时间之前（入场时未过期，之后过期），只显示到期日+1天
        if (amount > 0 && latest_in_time && new Date(latest_in_time) < new Date(endDate)) {
          // 入场时间在到期时间之前，不显示日期选择器
          this.showDateRadio = false
          this.showDateCase = null
        } else {
          // 其他到期情况，显示日期选择器
          this.showDateRadio = true
          if (amount > 0) {
            // 车辆在场
            if (util.countDateIsToday(latest_in_time)) {
              // 情况2：入场时间是今天
              this.vhInDateVal = common.format(latest_in_time, 'yyyy-MM-dd')
              this.showDateCase = 2
            } else {
              // 情况1：入场时间不是今天（只比较日期部分）
              const inDate = new Date(latest_in_time)
              inDate.setHours(0, 0, 0, 0)
              const todayDate = new Date(today)
              todayDate.setHours(0, 0, 0, 0)
              if (inDate < todayDate) {
                // 入场日期 < 今天日期
                this.vhInDateVal = common.format(latest_in_time, 'yyyy-MM-dd')
                this.showDateCase = 1
              }
            }
          } else {
            // 车辆没有入场
            // 情况3
            this.vhInDateVal = common.format(today, 'yyyy-MM-dd')
            this.showDateCase = 3
          }
        }
      } else {
        this.showDateRadio = false
        // 其他情况
        this.showDateCase = null
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  async mounted () {
    this.isVueReady = true
    this.setButtonClertload()
    if (common.getUserAgent() === common.userAgentInfo.wx) {
      this.WX_Bridge_ready(() => {
        this.setButtonClertload()
      })
    } else if (common.getUserAgent() === common.userAgentInfo.zfb) {
      this.ZFBReady(() => {
        this.setButtonClertload()
      })
    }

    await this.ensurePayContext()

    // 判断是否需要进行支付
    const sessionStorageLocal = JSON.parse(
      sessionStorage.getItem(constant.keyBusinessInfoSession)
    )
    const saveInfo = JSON.parse(
      sessionStorage.getItem(constant.keySaveInfoSession)
    )
    const monthUnitColumnsListNew = JSON.parse(
      sessionStorage.getItem(constant.keyMonthUnitColumnsListSession)
    )

    if (monthUnitColumnsListNew && monthUnitColumnsListNew.length > 0) {
      this.monthUnitColumnsLocal = monthUnitColumnsListNew
    }
    const detailObj = JSON.parse(sessionStorage.getItem('postponeDetail'))
    // 判断查询车辆和展示车辆是否一致，一致的话突出显示
    // const payTypeLocal = sessionStorage.getItem(constant.keyPayTypeSession)

    // this.code = this.$route.query.code
    const comparePayType = Number(this.thePayType)

    const needCode =
      comparePayType === common.payType.wx ||
      comparePayType === common.payType.zfb ||
      comparePayType === common.payType.abc ||
      comparePayType === common.payType.zero
      // 需要code
      // 获取code

    if (sessionStorageLocal && needCode && saveInfo) {
      this.getTempBackTimeout()

      this.detail = detailObj
      this.detail.monthOrGroup = detailObj.monthOrGroup
      if (detailObj.group_vh_charge_mobile_type) {
        this.detail.group_vh_charge_mobile_type = detailObj.group_vh_charge_mobile_type
      }

      // if (common.getUserAgent() === common.userAgentInfo.wx) {
      const urlParams = new URLSearchParams(window.location.search)
      this.code = urlParams.get('code') || this.$route.query.code

      // this.code = this.$route.query.code
      // }
      // }
      // 数据回显
      // this.plateNumber = sessionStorageLocal.plate_number.split('')
      // this.radioSelVal = Number(sessionStorageLocal.vh_cate_id)
      // this.monthNum = Number(sessionStorageLocal.month)
      // this.waitPayMoney = Number(sessionStorageLocal.monthly_rent_fee)
      // this.payTypeLocal = payTypeLocal
      // this.vh_cate_name = this.detail.vh_cate_name
      if (sessionStorageLocal.specs_count !== undefined) {
        this.monthNum = sessionStorageLocal.specs_count || ''
      }
      if (saveInfo.monthUnitIndex !== undefined) {
        this.monthUnitIndex = saveInfo.monthUnitIndex
      }
      this.vhSpace = saveInfo.vhSpace ? saveInfo.vhSpace : 1

      this.vhInDateVal = saveInfo.vhInDateVal
      this.timeRadio = String(saveInfo.timeRadio)
      this.showDateRadio = saveInfo.showDateRadio
      this.showDateCase = Number(saveInfo.showDateCase)
      // 如果是从 sessionStorage 恢复，且没有日期选择，确保 dueDateVal 是到期日的下一天
      if (!this.showDateRadio && (this.detail.effective_date_end || this.detail.current_effective_date_end)) {
        this.dueDateVal = util.getNextDay(this.detail.effective_date_end || this.detail.current_effective_date_end)
      } else {
        this.dueDateVal = saveInfo.dueDateVal
      }

      this.defaultMoney = 0
      if (this.monthUnitColumnsLocal[this.monthUnitIndex].month_count === 1) {
        this.defaultMoney = this.monthUnitColumnsLocal[this.monthUnitIndex].current_price
      } else {
        this.defaultMoney = 0
      }
      // this.payMoney =
      //   (Number(this.detail.month_rent) / 100) * sessionStorageLocal.month
      // 当没有规格时，构造规格
      // this.$dialog
      //   .alert({
      //     title: '123',
      //     message: JSON.stringify(saveInfo)
      //   })
      //   .then(() => {
      //   })

      if (this.monthUnitColumnsLocal.length > 0) {
        this.countMoney(
          this.monthUnitColumnsLocal[this.monthUnitIndex].current_price / 100,
          this.monthNum
        )
      }
      if (this.detail.monthOrGroup === 'store') {
        this.storeNum = Number(saveInfo.storeNum)
        this.payMoney = Number(saveInfo.storeNum)
      }
      // this.$dialog
      //   .alert({
      //     title: '123',
      //     message: this.payMoney
      //   })
      //   .then(() => {
      //   })
      // this.countRentDate(this.detail.effective_date_end)

      if (this.code) {
        Toast.loading({
          forbidClick: true,
          message: '请稍候...'
        })
        this.doPay()
      } else {
        // this.getAllCode()
        this.$dialog
          .alert({
            title: '支付失败',
            message: 'code失效'
          })
          .then(() => {
            this.onClickLeft()
          })
      }
      return
    }
    console.log('接受到的参数', this.$route.query)

    this.detail = detailObj
    this.detail.monthOrGroup = detailObj.monthOrGroup
    // 开发环境调试不同情况
    // 添加测试数据
    // this.detail.vhPlates = arr
    console.log('接受到的参数detail', this.detail)
    // 延期时 增加判断 车辆是否在场 amount 大于0表示在场，可能不存在；latest_in_time 最近入场时间；latest_out_time 最近出场时间
    // 情况一 车辆到期后，车辆入场，多日后充值延期
    // 情况二 车辆到期后，车辆入场当天充值延期
    // 情况三 车辆到期后，车辆没有入场进行充值延期
    // 其余情况 只展示一个到期时间+1天即可

    this.countVhDate()

    // 设置车位（分组车续费时，价格需要乘以车位数量，如果为0，则按照1计算。）等待接口返回车位数量
    if (this.detail.group_info) {
      this.vhSpace = this.detail.group_info.total === 0 ? 1 : this.detail.group_info.total
    }
    // 分组车
    // 储值车
    // 月租车 月卡车 其他
    // 获取分组车充值类型 1给查询的车辆延期；2给整个分组延期；3给分组储值
    if (this.detail.group_vh_charge_mobile_type) {
      this.group_vh_charge_mobile_type =
        this.detail.group_vh_charge_mobile_type
    }
    // 获取分组车内各个车辆
    if (this.detail.monthOrGroup === 'group') {
      if (this.detail.group_info) {
        if (this.detail.group_info.vh_list.length > 0) {
          this.vhPlates = this.detail.group_info.vh_list
        }
      }
    }
    console.log('分组的车辆', this.vhPlates)

    // 获取规格
    if (this.detail.default_rent) {
      if (this.detail.default_rent.specs_info) {
        if (this.detail.default_rent.specs_info.online_recharge_enable) {
          const specsList = this.detail.default_rent.specs_info.specs_list
          specsList.forEach((x, xIndex) => {
            // "month_count": 1, // 多少个月
            // "original_price": 10000, // 原价，单位：分
            // "current_price": 9500
            const obj = {
              id: xIndex,
              month_count: x.month_count,
              month_count_name: x.month_count + '个月',
              original_price: x.original_price,
              current_price: x.current_price,
              value: this.detail.vh_cate_id,
              name: this.detail.vh_cate_name,
              vh_cate_id: this.detail.vh_cate_id
            }
            this.monthUnitColumnsLocal.push(obj)
          })
        }
      } else {
        // 普通月租车
        const defaultMonthRent = this.detail.default_rent.month_rent
          ? this.detail.default_rent.month_rent
          : 0 // 默认月租金
        this.defaultRent = defaultMonthRent
        const obj = {
          id: 0,
          month_count: 1,
          month_count_name: '1个月',
          original_price: defaultMonthRent,
          current_price: defaultMonthRent,
          value: this.detail.vh_cate_id,
          name: this.detail.vh_cate_name,
          vh_cate_id: this.detail.vh_cate_id
        }
        this.monthUnitColumnsLocal.push(obj)
      }
    }
    // const defaultRent = this.detail.month_rent / 100 // 默认月租金
    // this.defaultRent = defaultRent
    // if (this.monthUnitColumnsLocal.length > 0) {
    if (this.detail.monthOrGroup === 'group') {
      if (this.detail.group_vh_charge_mobile_type === 3) {
        this.payMoney = 0
      } else {
        this.countMoney(
          this.monthUnitColumnsLocal[this.monthUnitIndex].current_price / 100,
          this.monthNum
        )
      }
    } else if (this.detail.monthOrGroup === 'store') {
      this.payMoney = 0
    } else {
      this.countMoney(
        this.monthUnitColumnsLocal[this.monthUnitIndex].current_price / 100,
        this.monthNum
      )
    }
    // }
    // 整理 默认月租金
    this.defaultMoney = 0
    if (this.monthUnitColumnsLocal[0].month_count === 1) { // 这里提示 vue.runtime.esm.js:3065 TypeError: Cannot read property 'month_count' of undefined
      this.defaultMoney = this.monthUnitColumnsLocal[0].current_price
    } else {
      this.defaultMoney = 0
    }
    // this.defaultMoney = defaultMoney
    this.countRentDate(this.detail.effective_date_end || this.detail.current_effective_date_end)
    this.isVueReady = true
    if (common.getUserAgent() === common.userAgentInfo.wx) {
      this.WX_Bridge_ready(() => {
        this.setButtonClertload()
      })
    } else if (common.getUserAgent() === common.userAgentInfo.zfb) {
      this.ZFBReady(() => {
        this.setButtonClertload()
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    // 调用方法清除 session 数据
    if (to.path === '/reletPostpone') {
      this.clearSessionData()
      sessionStorage.removeItem('postponeDetail')
    }
    // 继续路由导航
    next()
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      if (from.path === '/reletPostpone') {
        vm.clearSessionData()
        vm.payBtnLoading = false
      }
      if (from.path === '/postponeDetail') {
        vm.payBtnLoading = false
      }
    })
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后

  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.page {
  background-color: #f8f7fc;
}
.mainBox {
  ::v-deep .van-divider {
    margin: 0;
  }
  .boxItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.1rem 0;
   ::v-deep .van-cell{
        padding: 0;;
    }
  }
  .otherItem {
    padding: 0.1rem;
    margin-top: 0.16rem;
    background-color: #fff;
    display: flex;
    align-items: center;
  }
  .otherTipItem{
    padding: 0.1rem;
    margin-top: 0.16rem;
    background-color: #fff;
    text-align: left;
    .leftTitDesc{
      font-size: 0.18rem;
      color: #999;
      font-weight: 500;
    }
    .rightMoneyDesc{
      font-size: 0.16rem;
      color: #999;
    }
  }
  .monthBox {
    padding: 0 0.16rem;
    margin-top: 0.16rem;
    background-color: #fff;

    .title {
      font-size: 0.16rem;
      color: #333;
      line-height: 0.22rem;
      justify-content: flex-start;

      .mainBoxLeftIcon {
        width: 0.18rem;
        height: 0.14rem;
        // margin: 0.03rem 0 0.43rem 0;
      }

      // .img img{
      //   width: 100%;
      //   height: 100%;
      // }
    }
    .nowDates {
      // margin-top: 0.1rem;
      padding: 0.1rem 0;
    }
  }
  .leftTit {
    font-size: 0.16rem;
    // color: #999;
    color: rgba(0, 0, 0, 1);
    font-weight: 500;
  }
  .rightValue {
    font-size: 0.16rem;
    color: #333;
  }
  .rightMoney {
    font-size: 0.18rem;
    color: #333;
  }
  // 分组车
  .groupWrapBox {
    margin-top: 0.1rem;
    .groupBoxItem {
      background-color: #fff;
      padding: 0.06rem 0.16rem 0.16rem;
      margin-bottom: 0.16rem;
      .names {
        display: flex;
        .groupName {
          font-size: 0.12rem;
          color: #333;
          font-weight: bold;
          line-height: 0.2rem;
          margin-left: 0.06rem;
        }
      }

      .dates {
        font-size: 0.14rem;
        line-height: 0.17rem;
        // padding-left: 0.22rem;
        text-align: left;
      }
      .plates {
        // display: flex;
        // margin-top: 0.1rem;
        // margin-bottom: 0.06rem;
        // // padding-left: 0.22rem;
        // display: flex;
        // flex-wrap: wrap;
        // justify-content: space-between;
        // justify-content: flex-start;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start; /* 左对齐 */
        gap: 0.1rem; /* 设置子元素之间的间距 */
        padding: 0.1rem 0 0.1rem 0.1rem;

        .platesShowItem {
          // padding: 0.05rem 0.1rem;
          // color: #000;
          // font-size: 0.1rem;
          // // margin-right: 0.1rem;
          // margin-bottom: 0.1rem;
          // background-color: #f4f4f4;
          // border-radius: 0.12rem;
          // display: flex;
          // flex-direction: column;
          // text-align: left;
          flex: 0 0 calc(22% - 0.1rem); /* 使用calc来减去间距的一半，确保四个元素一行 */
          padding: 0.05rem;
          color: #000;
          font-size: 0.1rem;
          background-color: #f4f4f4;
          border-radius: 0.12rem;
          display: flex;
          flex-direction: column;
          align-items: center; /* 文本对齐 */
          // text-align: left;
        }
      }
      .showWhenSelGroup {
        .monthFooter {
          display: flex;
          justify-content: space-between;
          margin-top: 0.1rem;
          .leftTit {
            font-size: 0.16rem;
            color: #999;
          }
        }
        .monthFooterDate {
          margin-top: 0.1rem;
          margin-bottom: 0.1rem;
          .rightValue {
            font-size: 0.16rem;
            color: #333;
          }
        }
      }
    }
  }
  .btnOperation {
    display: flex;
    justify-content: center;
    .query_btn {
      width: 100%;
      background-color: #4797ea;
      border-radius: 0.04rem;
      margin-top: 0.3rem;
      // display: flex;
      // flex-direction: column;
      // padding: 0.1rem 1.21rem 0.1rem 1.21rem;
      margin-left: 0.16rem;
      margin-right: 0.16rem;
      .query_btn_text {
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 0.16rem;
        font-family: PingFangSC-Regular;
        font-weight: normal;
        text-align: left;
        white-space: nowrap;
        line-height: 0.22rem;
      }
    }
  }
}
.specialVh {
  color: red;
}
.vhNum {
  margin-left: 0.05rem;
}
.vhCate {
  margin-left: 0.05rem;
  padding: 0 0.05rem;
  font-size: 0.12rem;
  color: #fff;
  border-radius: 25px;
  background-color: #4797ea;
}

.dateBox{
.showDateCaseText{
  font-size: 14px;
  color: #999;
}
.rightDateCaseText{
  font-size: 16px;
}
}
</style>
